var $7ca8b98be6a41a9c$exports = {};
$7ca8b98be6a41a9c$exports = {
    "replaceMessage": `\u{653E}\u{7F6E}\u{8981}\u{53D6}\u{4EE3}\u{7684}\u{6A94}\u{6848}`
};


export {$7ca8b98be6a41a9c$exports as default};
//# sourceMappingURL=zh-TW.mjs.map
